export default {
    apiKey: 'AIzaSyC2gMSsjGltQH095sSdE0MLCcdFUuvi19U',
    authDomain: 'konsiergelite.firebaseapp.com',
    databaseURL: 'https://konsiergelite.firebaseio.com',
    projectId: 'konsiergelite',
    storageBucket: 'konsiergelite.appspot.com',
    messagingSenderId: '273942130252',
    appId: '1:273942130252:web:5b1462266de2ae232ecee9',
    measurementId: 'G-62GX15RXV1'
};



// WEBPACK FOOTER //
// ./src/lib/firebaseAuthObject.ts